import { createContext } from 'react';

const ConsoleModalContext = createContext(null);

export default ConsoleModalContext;



// WEBPACK FOOTER //
// ./containers/console/context/console-modal-context.js